// ajax
import axios from 'axios';
import CGI_PATH from '../constants/cgiPath';
import { ShowTips } from '@tencent/hymixed-pcapi';
import { getPlatform } from 'utils';
import { appid } from '../../../config/retcode.config.js';
// import retcodeReport from 'js/common/retcode-report';

let platform = getPlatform();

// 包装param，产生有错误图标的提示
var wrapMsg = function(msg) {
    console.log(msg);
    // 错误信息上报收集
    return {
        text: msg,
        iconMode: 2,
    };
};

const api = axios.create({
    timeout: 5000,
    withCredentials: true,
    headers: {
        post: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    },
});

api.interceptors.response.use(
    function(response) {
        var { msg, retcode, errCode } = response.data;
        msg = msg || response.data.message; // uploadImage 是res.data.message
        // 无异常，正常返回（提取出返回中的真正数据后返回）
        if (retcode === 0 || errCode === 0) {
            return response.data; // uploadImage用的是 res.data.data
        }

        // 网络正常，逻辑错误
        var err = new Error(msg);
        err.retcode = retcode || errCode; // uploadImage 用的是 errCode

        // 未登录，统一处理
        if (retcode === 100000) {
            ShowTips(wrapMsg('未登录，请登录后重试：' + msg));
            err.message = '未携带登陆态';
            err.handled = true;
        }

        if (retcode === 100003 || retcode === 100012) {
            ShowTips(wrapMsg('服务器错误，请稍后重试：' + msg));
            err.handled = true;
        }

        return Promise.reject(err);
    },
    function(err) {
        // 这里只区分不同的错误类型，暂不做特殊处理
        var isTimeout = err.message.indexOf('timeout') > -1;
        var isNetworkErr = err.message === 'Network Error';
        var isServerErr = err.response && err.response.status;

        if (isTimeout) {
            ShowTips(wrapMsg('请求超时，请稍后重试：' + err.message));
        } else if (isNetworkErr) {
            ShowTips(wrapMsg('网络错误，请检查网络后重试：' + err.message));
        } else {
            ShowTips(wrapMsg('请求失败，请检查网络后重试：' + err.message));
        }
        err.handled = true;

        return Promise.reject(err);
    }
);

function fetch(next, nextAction, cgiName, params, onSuccess, onError, opts) {
    if (!CGI_PATH[cgiName]) {
        console.error(`没有找到该cgi对应的路径！ <${cgiName}>`);
    }

    let { method = 'GET', param } = params;

    let cgiStartTime = Date.now();

    return api({
        method: method.toLowerCase(),
        url: CGI_PATH[cgiName],
        params: param,
    })
        .then((data) => {
            params.data = data;

            // 返回码上报
            let retcode = data.retcode,
                type;
            if (retcode === 0) {
                type = 1;
            } else if (retcode === 100003 || retcode === 100012) {
                type = 2;
            } else {
                type = 3;
            }

            window.QReport &&
                window.QReport.retcode({
                    appid: appid,
                    platform: platform,
                    url: CGI_PATH[cgiName],
                    type: type,
                    code: retcode,
                    time: Date.now() - cgiStartTime,
                    rate: type === 1 ? 10 : 1,
                });

            //  触发请求成功的action
            let re = next(nextAction(cgiName + '_SUCCESS', params, opts));
            onSuccess && onSuccess(data);

            return re;
        })
        .catch((err) => {
            params.data = err;
            console.log(err);
            // 返回码上报：网络错误

            let retcode = err.retcode,
                type;

            if (retcode === 100003 || retcode === 100012 || !retcode) {
                type = 2;
            } else {
                type = 3;
            }
            window.QReport &&
                window.QReport.retcode({
                    appid: appid,
                    platform: platform,
                    url: CGI_PATH[cgiName],
                    type: type,
                    code: retcode || (err.response ? err.response.status : -1),
                    time: Date.now() - cgiStartTime,
                    rate: 1,
                });

            //  触发请求失败的action
            let re = next(nextAction(cgiName + '_ERROR', params, opts));
            onError && onError(err);

            return re;
        });
}

export default (store) => (next) => (action) => {
    let API_OPT = action['API'];

    if (!API_OPT) {
        return next(action);
    }

    // let ACTION_TYPE = action['type'];
    let { cgiName, params, opts = {} } = API_OPT;

    let { onSuccess, onError } = params;

    // 触发下一个action
    let nextAction = function(type, params, opts) {
        action['type'] = type;
        action['opts'] = opts;
        delete params['onSuccess'];
        delete params['onError'];
        const nextRequestAction = { ...action, ...params };
        return nextRequestAction;
    };

    params.data = null;
    // 触发正在请求的action
    let result = next(nextAction(cgiName + '_ON', params, opts));

    if (window.PreLoad) {
        window.PreLoad.getData(
            cgiName,
            (data) => {
                if (!data) {
                    return fetch(
                        next,
                        nextAction,
                        cgiName,
                        params,
                        onSuccess,
                        onError,
                        opts
                    );
                }

                params.data = data;

                // 返回码上报
                let retcode = data.retcode,
                    type;
                if (retcode === 0) {
                    type = 1;
                } else if (retcode === 100003 || retcode === 100012) {
                    type = 2;
                } else {
                    type = 3;
                }

                window.QReport &&
                    window.QReport.retcode({
                        appid: appid,
                        platform: platform,
                        url: CGI_PATH[cgiName],
                        type: type,
                        code: retcode,
                        time:
                            window.PreLoad.ajaxEndTime[cgiName] -
                            window.PreLoad.ajaxStartTime[cgiName],
                        rate: type === 1 ? 10 : 1,
                    });

                let re = next(nextAction(cgiName + '_SUCCESS', params, opts));
                onSuccess && onSuccess(data);

                return re;
            },
            function() {
                fetch(
                    next,
                    nextAction,
                    cgiName,
                    params,
                    onSuccess,
                    onError,
                    opts
                );
            }
        );
    } else {
        fetch(next, nextAction, cgiName, params, onSuccess, onError, opts);
    }

    return result;
};
